export const commissionTypeOptions = [
  { value: 'lot-based', label: 'Lot-based' },
  { value: 'revenue-share', label: 'Revenue Share' },
  { value: 'hybrid', label: 'Hybrid' },
];

export interface CommissionRulesData {
  commissionType: string;
  commissionRate: number;
  minimumPayoutAmount: number;
  negativeBalanceProtection: boolean;
}

export interface CommissionRulesProps {
  data: CommissionRulesData;
  onChange: (data: CommissionRulesData) => void;
}
